export default __webpack_public_path__ + "static/antero_team-62566a06bc57304de0cb8d125c220cc1.jpg";